import { LoadingSpinner } from './components/loading-spinner';
import { Skeleton } from '@/components/ui/skeleton';

export const Loading = () => {
  return (
    <div className='w-full h-full mx-auto'>
      <div className='flex gap-4 animate-pulse h-full'>
        <Skeleton className='h-full w-64' />
        <div className='flex items-center justify-center grow'>
          <LoadingSpinner />
        </div>
      </div>
    </div>
  );
};
